import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'
import { Header, Menu, Footer } from '../../'

import contactOne from '../../../assets/images/contact/contact_01.jpg'
import contactTwo from '../../../assets/images/contact/contact_02.jpg'
import contactThree from '../../../assets/images/contact/contact_03.jpg'

import contactFour from '../../../assets/images/contact/contact_04.jpg'
import contactFive from '../../../assets/images/contact/contact_05.jpg'
import contactSix from '../../../assets/images/contact/contact_06.jpg'

class ContactDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      items: [
        {
          title: 'สาขาสี่มุมเมือง ตลาดสี่มุมเมือง ซอย 3 เลขที่ 3/31',
          img: contactOne
        },
        {
          title: 'สาขาเตาปูน ตลาดมณีพิมาณ แผงที่ 12',
          img: contactTwo
        },
        {
          title: 'สาขาสำโรง ตลาดเขมร ล็อคที่ 3',
          img: contactThree
        },
        {
          title: 'สาขาสะพานใหม่ ตลาดสะพานใหม่ เลขที่ร้าน AH0007',
          img: contactFour
        },
        {
          title: 'สาขาสะพานใหม่(ปิ้ง-ย่าง) ตลาดสะพานใหม่',
          img: contactFive
        },
        {
          title: 'สาขาพระราม3 ตลาดพระราม3 อยู่บริเวณหัวมุม',
          img: contactSix
        }
      ]
    }
  }
  render() {
    return (
      <>
        <Header />
        <div className="container-lg p-0">
          <Menu />
        </div>
        <div className="ch-contact-detail">
          <div className="container-lg">
            <h1 className="display-4 text-center font-weight-bold">
              <span>ที่ตั้ง & สาขา</span>
            </h1>
            <div className="row">
              <div className="col-12">
                {this.state.items.map((data, i) => {
                  return (
                    <div className="ch-contact-detail-box" key={i}>
                      <img className="img-fuild" src={data.img} alt="chefhung-contact" />
                      <div className="ch-contact-detail-title">
                        <h4>{data.title}</h4>
                        <h4>
                          <FontAwesomeIcon icon="phone" /> 06-3393-0084
                        </h4>
                        <h4>
                          <FontAwesomeIcon icon="phone" /> 06-3393-0083
                        </h4>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    )
  }
}

export default ContactDetail
